import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  evalCondition,
  storeGet,
} from "mailup-react-helpers";

import {
  FILTER_TYPE_ENGAGEMENT,
  type FilterType,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters,
} from "Api/beFiltersApi";

import type { FiltersOption, FiltersOptionsGroup } from "./model";

import getIntl from "Helpers/intl";

import { LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED } from "Constants";

export const fetchFilters = async (): Promise<{
  optionsGroups: FiltersOptionsGroup[];
  options: FiltersOption[];
}> => {
  const idList = storeGet(STORE_KEY_ID_LIST);
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE);
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined;

  const hasEngagementFilters: boolean = evalCondition(
    "co:DELSTATS OR co:ENGAGEMENT",
  );
  //
  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: "Name",
    orderDescending: false,
  });

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: "Load.Filters.WithoutCategory" }),
    },
    ...categories.Items,
  ];

  const availableFilterTypes: FilterType[] = [
    "Anagraphic",
    "Activity",
    "Device",
    "Geolocation",
    "MultiType",
    "Tracking",
  ];
  if (hasEngagementFilters) {
    availableFilterTypes.push("Engagement");
  }

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 1000, // TODO: transform the select that uses this method in an AsyncSelect to avoid fetching 1000 items
      pageNumber: 1,
      orderBy: "Name",
      orderDescending: false,
      hidden,
      types: availableFilterTypes,
    })
  ).Items;

  const result = {
    optionsGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id),
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name,
    })),
  };

  return result;
};
